<template>
  <div class="row">
    <div class="col-md-12">
        <div class="radio">
            <input class="magic-radio" type="radio" name="radio" id="r1" v-model="book.ordering" value="option1" @click="orderingVols(bookVols)">
            <label for="r1" class="radio1">排序</label>
        </div>
        <span class="magic-radio_icon">⇅</span>
    </div>
    <div class="col-md-12">
        <div class="episode_wrap">
            <a v-for="(vol, idx) of bvs" :key="idx">
              <div class="episode_icon" :class="{'episode_icon1': vol.SelectedBook, 'episode_icon2': vol.selected, 'episode_icon3': vol.IsPurchased, 'episode_icon4': !vol.IsPurchased }" @click="toggleVolStatus(vol)">
              <div class="empty-reddot" :class="{'reddot': vol.IsPromotion}"></div>{{vol.Vol}}</div>
            </a>
            <!-- <a v-for="vol of bookVols" :href="vol.BookID"><div class="episode_icon" :class="{'episode_icon1': vol.IsPurchased, 'episode_icon2': vol.IsPromotion, 'episode_icon3': : vol.SelectedBook }"><div class="reddot"></div>{{vol.Vol}}</div></a> -->
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'
import Remodal from './Remodal.vue'
import Subscribe from './Subscribe.vue'

export default {
  name: 'BookVols',
  props: ["bvs"],
  data () {
    return {

    }
  },
  methods: {
    ...user,
    toggleVolStatus(vol) {
      if (vol.selected) {
        vol.selected = true
      } else {
        // vol.selected = false
        // window.open(vol.viewer)
      }
    }
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  },
  components: {
    Remodal,
    Subscribe
  }
}
</script>



// WEBPACK FOOTER //
// src/BookVols.vue